import Vue from "vue";

// Extend the Vue interface to have the $localStorage and $sessionStorage properties
declare module "vue/types/vue" {
  interface Vue {
    $localStorage: Storage;
    $sessionStorage: Storage;
  }
}

/**
 * This registers localStorage and sessionStorage as properties on Vue. This is so that unit tests can mock out each
 * storage object using a test plugin
 * @param vue
 */
export default function install(vue: typeof Vue) {
  vue.prototype.$localStorage = localStorage;
  vue.prototype.$sessionStorage = sessionStorage;
}
